import { render } from "./contentTable.vue?vue&type=template&id=13b36c2a&scoped=true"
import script from "./contentTable.vue?vue&type=script&lang=js"
export * from "./contentTable.vue?vue&type=script&lang=js"

import "./contentTable.vue?vue&type=style&index=0&id=13b36c2a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b36c2a"]])

export default __exports__